module.exports = __webpack_public_path__ + "img/top.9e8e3a05.png";